import { render, staticRenderFns } from "./select-district.vue?vue&type=template&id=060e1a28&"
import script from "./select-district.vue?vue&type=script&lang=js&"
export * from "./select-district.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports